<template>
  <button
      :type="type ? type : ''"
      class="button"
      :disabled="isDisabled"
      :class="[{active: isLoading}]"
  >
    <ui-loader class="button__loader" v-if="isLoading" />
    <slot v-else />
  </button>
</template>

<script setup>
import UiLoader from "@/components/ui/ui-loader.vue";

const props = defineProps({
  isDisabled: Boolean,
  isLoading: Boolean,
  type: String
})
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  width: 100%;
  padding-block: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: transparent;
  border-radius: 27px;
  border: 1px solid #222;
  transition: 0.2s;

  color: #222;
  font-size: 21px;
  font-weight: 500;
  line-height: 27px;

  @include hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    @include hover {
      background-color: transparent;
      color: #222;
    }
  }

  &__loader {
    margin-block: 7px;
  }
}

@media (max-width: 500px) {
  .button {
    font-size: 18px;
  }
}
</style>